<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">{{ isEditMode ? '✏️ Editar Fornecedor' : '➕ Novo Fornecedor' }}</h1>
    <p class="text-gray-600 mt-2">{{ isEditMode ? 'Atualize os dados do fornecedor' : 'Cadastro manual de fornecedor (Shadow Profile)' }}</p>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <!-- Form Principal -->
    <div class="lg:col-span-2">
      <div class="bg-white rounded-lg shadow p-6">
        <div *ngIf="!isEditMode" class="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-md text-blue-800">
          <p class="font-semibold mb-2">ℹ️ Shadow Profile (Cadastro Admin)</p>
          <ul class="text-sm space-y-1">
            <li>✓ Fornecedor será criado sem necessidade de autoCadastro</li>
            <li>✓ Receberá email com credenciais de acesso (Login + Senha)</li>
            <li>✓ Pode gerenciar perfil e galeria de fotos</li>
            <li>✓ Receberá leads conforme o plano</li>
          </ul>
        </div>

        <div *ngIf="isEditMode" class="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-md">
          <div class="font-semibold mb-3 text-gray-800">👤 Informações do Usuário</div>
          <div *ngIf="loadingSupplierUser" class="text-sm text-gray-600">🔄 Carregando...</div>
          <div *ngIf="!loadingSupplierUser && supplierUser" class="text-sm space-y-2">
            <div class="flex justify-between">
              <span class="text-gray-600">Email de login:</span>
              <span class="font-mono bg-gray-100 px-2 py-1 rounded">{{ supplierUser.email }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Status:</span>
              <span [class]="supplierUser.isActive ? 'text-green-600 font-semibold' : 'text-red-600 font-semibold'">
                {{ supplierUser.isActive ? '✓ Ativo' : '✗ Inativo' }}
              </span>
            </div>
            <div *ngIf="supplierUser.ultimoAcesso" class="flex justify-between">
              <span class="text-gray-600">Último acesso:</span>
              <span>{{ supplierUser.ultimoAcesso | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
          <div *ngIf="!loadingSupplierUser && !supplierUser" class="text-sm text-gray-600 italic">
            Nenhum usuário Supplier vinculado. Clique em "Reenviar email de boas-vindas" para criar/reenviar as credenciais.
          </div>
          <button type="button" (click)="resendWelcomeEmail()" [disabled]="resending" class="mt-3 px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 disabled:opacity-50">
            {{ resending ? '📧 Enviando...' : '📧 Reenviar email de boas-vindas' }}
          </button>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
          <!-- Informações Básicas -->
          <div>
            <h3 class="text-lg font-semibold text-gray-700 mb-4">📋 Informações Básicas</h3>
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Nome do Fornecedor <span class="text-red-500">*</span></label>
                <input formControlName="nome" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Ex: Doce Sonho Bolos" />
                <div *ngIf="form.controls['nome'].errors?.['required'] && form.controls['nome'].touched" class="text-sm text-red-600 mt-1">Nome é obrigatório</div>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Slug (URL)</label>
                  <input formControlName="slug" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="doce-sonho-bolos" />
                  <p class="text-xs text-gray-500 mt-1">Gerado automaticamente do nome</p>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Categoria <span class="text-red-500">*</span></label>
                  <select formControlName="categoriaId" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option [ngValue]="null">-- Selecione uma categoria --</option>
                    <option *ngFor="let c of categories" [value]="c.id">{{ c.nome }}</option>
                  </select>
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
                <textarea formControlName="descricao" rows="4" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Descreva o fornecedor em poucas linhas..."></textarea>
              </div>
            </div>
          </div>

          <!-- Localização e Contato -->
          <div>
            <h3 class="text-lg font-semibold text-gray-700 mb-4">📍 Localização e Contato</h3>
            <div class="space-y-4">
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Cidade (Principal)</label>
                  <input formControlName="cidade" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Ex: Piracicaba" />
                  <p class="text-xs text-gray-500 mt-1">Campo legado — use "Cidades Atendidas" abaixo</p>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Estado (UF)</label>
                  <select formControlName="estado" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="">Selecione</option>
                    <option *ngFor="let uf of estados" [value]="uf">{{ uf }}</option>
                  </select>
                </div>
              </div>

              <!-- Multi-city selector -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">🌆 Cidades Atendidas (Multi-Cidade)</label>
                <div class="border border-gray-300 rounded-md overflow-hidden bg-white">
                  <div *ngIf="cidades.length === 0" class="p-4 text-sm text-gray-500 text-center italic">
                    <div class="mb-2">📭 Nenhuma cidade cadastrada</div>
                    <a routerLink="/admin/cidades/new" class="text-blue-600 hover:underline inline-flex items-center gap-1">
                      <span>➕ Cadastrar primeira cidade</span>
                    </a>
                  </div>
                  <div *ngIf="cidades.length > 0" class="divide-y max-h-64 overflow-y-auto">
                    <div *ngFor="let c of cidades; trackBy: trackByIdFn" class="flex items-center gap-3 p-3 hover:bg-gray-50 transition">
                      <input type="checkbox"
                        [id]="'cidade-' + c.id"
                        [(ngModel)]="cidadeCheckboxMap[c.id]"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="toggleCidade(c.id, cidadeCheckboxMap[c.id])"
                        class="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" />
                      <label [for]="'cidade-' + c.id" class="flex-1 cursor-pointer select-none">
                        <div class="text-sm font-medium text-gray-900">{{ c.nome }}</div>
                        <div class="text-xs text-gray-500">{{ c.estado }}</div>
                      </label>
                      <span *ngIf="cidadeCheckboxMap[c.id]" class="text-green-600 text-lg">✓</span>
                    </div>
                  </div>
                </div>
                <div class="mt-2 flex items-center justify-between">
                  <p class="text-xs text-gray-500">
                    <span class="font-medium text-gray-700">{{ selectedCidadesIds.length }}</span>
                    {{ selectedCidadesIds.length === 1 ? 'cidade selecionada' : 'cidades selecionadas' }}
                  </p>
                  <button type="button" 
                    *ngIf="selectedCidadesIds.length > 0"
                    (click)="selectedCidadesIds = []"
                    class="text-xs text-red-600 hover:text-red-800 font-medium">
                    ✕ Limpar seleção
                  </button>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Telefone</label>
                  <input formControlName="telefone" type="tel" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="(19) 99999-9999" />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">CNPJ</label>
                  <input formControlName="cnpj" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono" placeholder="12.345.678/0001-90" maxlength="18" />
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Endereço</label>
                <input formControlName="endereco" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Rua, número, bairro, cidade" />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Horário de Funcionamento</label>
                <input formControlName="horarioFuncionamento" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Ex: Seg-Sex 9h-18h, Sábado 9h-13h" />
              </div>
            </div>
          </div>

          <!-- Comunicação -->
          <div>
            <h3 class="text-lg font-semibold text-gray-700 mb-4">💬 Comunicação e Leads</h3>
            <div class="space-y-4">
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Email Público <span class="text-red-500">*</span></label>
                  <input formControlName="email" type="email" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="contato@empresa.com" />
                  <p class="text-xs text-gray-500 mt-1">Exibido no site público</p>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Email do Proprietário <span class="text-red-500">*</span></label>
                  <input formControlName="emailOwner" type="email" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="proprietario@empresa.com" />
                  <p class="text-xs text-gray-500 mt-1">Recebe os leads automaticamente</p>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">WhatsApp</label>
                  <input formControlName="whatsApp" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="19999999999" />
                </div>
              </div>
            </div>
          </div>

          <!-- Redes Sociais -->
          <div>
            <h3 class="text-lg font-semibold text-gray-700 mb-4">📱 Redes Sociais</h3>
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Instagram</label>
                <input formControlName="instagram" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="@usuario ou URL" />
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Website</label>
                  <input formControlName="website" type="url" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="https://exemplo.com" />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Facebook</label>
                  <input formControlName="facebook" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="URL ou @usuario" />
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Logo URL</label>
                <input formControlName="logoUrl" type="url" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="https://exemplo.com/logo.png" />
              </div>
            </div>
          </div>

          <!-- Status e Visibilidade -->
          <div>
            <h3 class="text-lg font-semibold text-gray-700 mb-4">⚙️ Status e Visibilidade</h3>
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Plano <span class="text-red-500">*</span></label>
                <select formControlName="planLevel" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option [ngValue]="null">-- Selecione um plano --</option>
                  <option *ngFor="let plan of planLevels" [ngValue]="plan.value">{{ plan.label }}</option>
                </select>
                <p class="text-xs text-gray-500 mt-1">
                  <strong>Free:</strong> Até 3 leads por período | <strong>Vitrine:</strong> Leads ilimitados
                </p>
              </div>

              <div class="space-y-3 mt-4 pt-4 border-t border-gray-200">
                <label class="flex items-center gap-3 cursor-pointer p-2 hover:bg-gray-50 rounded">
                  <input type="checkbox" formControlName="ativo" class="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500" />
                  <span class="text-sm font-medium text-gray-700">✓ Ativo</span>
                </label>
                <label class="flex items-center gap-3 cursor-pointer p-2 hover:bg-gray-50 rounded">
                  <input type="checkbox" formControlName="publicado" class="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500" />
                  <span class="text-sm font-medium text-gray-700">📢 Publicado (visível no site)</span>
                </label>
                <label class="flex items-center gap-3 cursor-pointer p-2 hover:bg-gray-50 rounded">
                  <input type="checkbox" formControlName="destaque" class="w-4 h-4 text-amber-600 rounded focus:ring-2 focus:ring-amber-500" />
                  <span class="text-sm font-medium text-gray-700">⭐ Destaque (destaque na categoria)</span>
                </label>
                <label class="flex items-center gap-3 cursor-pointer p-2 hover:bg-gray-50 rounded">
                  <input type="checkbox" formControlName="seloFornecedor" class="w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-green-500" />
                  <span class="text-sm font-medium text-gray-700">🏅 Selo Fornecedor (certificado)</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Buttons -->
          <div class="flex gap-3 pt-6 border-t">
            <button type="submit" [disabled]="form.invalid || saving" class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium">
              {{ saving ? '⏳ Salvando...' : (isEditMode ? '💾 Atualizar' : '➕ Criar Fornecedor') }}
            </button>
            <button type="button" (click)="cancel()" class="px-6 py-2 border border-gray-300 rounded-md hover:bg-gray-50 font-medium">
              ✕ Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Sidebar com Info -->
    <div class="lg:col-span-1">
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 sticky top-6">
        <h3 class="font-semibold text-blue-900 mb-3">ℹ️ Dicas Importantes</h3>
        <ul class="text-sm text-blue-800 space-y-2">
          <li><strong>Email Público:</strong> Exibido no site para contato geral</li>
          <li><strong>Email Proprietário:</strong> Essencial! Recebe todos os leads</li>
          <li><strong>Slug:</strong> Gerado automaticamente e usado na URL</li>
          <li><strong>Categoria:</strong> Necessária para aparecer nas buscas</li>
          <li><strong>Destaque:</strong> Aparece no topo da categoria (pago)</li>
          <li><strong>Status Ativo:</strong> Se desmarcado, é invisível</li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Media Manager (após criação) -->
  <div class="mt-8" *ngIf="createdId">
    <app-media-manager [fornecedorId]="createdId" [initialMedias]="initialMedias" (fornecedorReloaded)="onFornecedorReloaded($event)"></app-media-manager>
    <app-testemunho-manager class="mt-8" [fornecedorId]="createdId"></app-testemunho-manager>
  </div>
</div>
